export enum CompetitorStatus {
  RaceLeader = 'race-leader',
  Fleet = 'fleet',
  DivisionLeader = 'division-leader',
  RecordHolder = 'record-holder',
  Retired = 'retired'
}

export type CategoryDatapoint = {
  RaceEntryId: number;
  CategoryId: number;
  Name: string;
  Division: string; // numberstring?
  RaceTime: string; // datestring
  CatPlace: number;
  DivPlace: number;
}

export type YachtPosition = {
  RaceEntryId: number;
  DataTypeCode: string;
  Latitude: number;
  Longitude: number;
  SpeedOverGround: string; // numberstring
  CourseOverGround: string; // rotationstring
  DistanceToGo: number;
  DistanceToLeader: number;
  RaceStatus: string; // racestatus string
  Heading: string;
  PositionDescription: null | string;
  IsRetired: boolean;
  IsFinished: boolean;
  IsRacing: boolean;
}

type YachtLatestPoll = {
  RaceEntryId: number;
  ReceiveTime: string; // datetime string
  Latitude: number;
  Longitude: number;
  SpeedOverGround: string;
  CourseOverGround: string;
}

export type FleetDatapoint = {
  RaceEntryId: number;
  RaceId: number;
  Year: number;
  Name: string;
  IsLineHonourRecord: boolean;
  RaceTime: string; // datestring
  RaceStartTime: string; // datestring
  RaceTimeFormat: null | string; // racetimestring
  Categories: Array<CategoryDatapoint>;
  Position: YachtPosition; // Blessed position
  CmsUrl: string;
  Owner: string;
  Club: string;
  ShowOnMap: boolean;
  Body: null;
  Image: null;
  History: Array<YachtLatestPoll>; // Latest GPS positions

  /* client-side generated properties */
  status: CompetitorStatus;
  render: {
    latitude: number;
    longitude: number;
    sog: string;
    cog: string;
    timeUpdated: string; // datestring
  }
};

export type RhumblinePoint = {
  PointId: number;
  Longitude: number;
  Latitude: number;
}

export type Feature = {
  type: string; // "Feature"
  geometry: {
    type: string; // "Point"
    coordinates: number[];
  },
  properties: {
    title: string;
    sog: string;
    icon: string;
    relativeTime: string;
  };
}

export type YachtTrackPoint = {
  CourseOverGround: string; // number string
  DataTypeCode: string; // e.g. GPS
  DistanceToGo: number;
  DistanceToLeader: number;
  Heading: null | string;
  IsFinished: boolean;
  IsRacing: boolean;
  IsRetired: boolean;
  Latitude: number;
  Longitude: number
  PositionDescription: null | string;
  RaceEntryId: number;
  RaceStatus: string; // RaceStatus string
  SpeedOverGround: string; // number string
}
